import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const PUMP_URL =
    "https://pump.fun/coin/4dAwbA1GxBoEMrJPrynPnGViQcJW1NULVB1rTNzbpump";

const NAV = [
    { id: "features", label: "Features" },
    { id: "tokenomics", label: "Tokenomics" },
    { id: "roadmap", label: "Roadmap" },
    { id: "giveaway", label: "Giveaway" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-black/70 backdrop-blur-xl backdrop-saturate-150 border-b border-white/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="font-display text-lg sm:text-xl font-black tracking-tighter text-white"
                >
                    <span className="text-[#00F0FF]">SPACE</span>
                    <span className="text-white">_100X</span>
                </a>

                <nav className="hidden md:flex items-center gap-8">
                    {NAV.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            data-testid={`nav-link-${item.id}`}
                            className="text-sm tracking-[0.18em] uppercase text-slate-300 hover:text-[#00F0FF] transition-colors font-mono"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={PUMP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-buy-button"
                        className="hidden sm:inline-flex"
                    >
                        <Button
                            className="rounded-full px-5 h-10 bg-[#00F0FF] hover:bg-[#00F0FF]/90 text-black font-display font-bold tracking-tight uppercase text-xs shadow-[0_0_24px_rgba(0,240,255,0.45)] hover:shadow-[0_0_36px_rgba(0,240,255,0.7)] transition-all"
                        >
                            Buy Now
                        </Button>
                    </a>
                    <button
                        data-testid="mobile-menu-toggle"
                        onClick={() => setOpen((s) => !s)}
                        className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/10 text-white"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl"
                >
                    <div className="px-5 py-5 flex flex-col gap-4">
                        {NAV.map((item) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${item.id}`}
                                className="text-sm tracking-[0.18em] uppercase text-slate-200 hover:text-[#00F0FF] font-mono"
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href={PUMP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="mobile-buy-button"
                        >
                            <Button className="w-full rounded-full bg-[#00F0FF] text-black font-display font-bold uppercase tracking-tight">
                                Buy on Pump.fun
                            </Button>
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
